import React, { Component } from "react";
import { FlatButton, Dialog, IconButton, Checkbox } from "material-ui";

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import closeIcon from "../../images/close_icon.png";
import searchIcon from "../../images/search.png";
import deleteDefaultIcon from "../../images/delete_default.png";
import editDefaultIcon from "../../images/edit_default.png";
import ReactTooltip from "react-tooltip";

export default class ShowUserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      userList: this.props.userList,
      toastOpen: false,
      responseMsg: "",
      address: "",
      searchTextValue: "",
      currentSelectedRow: "",
      openDeleteConfirmPopup: false,
      selectedRow: [],
    };
    this.buttonFormatter = this.buttonFormatter.bind(this);
    this.checkButtonFormatter = this.checkButtonFormatter.bind(this);
  }

  componentWillReceiveProps(props) {
    this.showOpenPopup(props.open, props.userList);
  }

  buttonFormatter(cell, row) {
    return (
      <div>
        <IconButton
          onClick={() => {
            this.editMailingTypeListUser(row);
          }}
          style={{
            width: "25px",
            height: "25px",
            padding: "0px",
            paddingLeft: "15px",
          }}
        >
          <p data-tip="Edit" data-for="editGroup">
            <img src={editDefaultIcon} />
          </p>
          <ReactTooltip id="editGroup" />
        </IconButton>
        <IconButton
          onClick={() => {
            this.deleteMailingTypeListUser(row);
          }}
          style={{ width: "25px", height: "25px", paddingLeft: "20px" }}
        >
          <p data-tip="Edit" data-for="editGroup">
            <img src={deleteDefaultIcon} />
          </p>
          <ReactTooltip id="editGroup" />
        </IconButton>
      </div>
    );
  }

  checkButtonFormatter(cell, row) {
    return (
      <Checkbox
        color="primary"
        checked={
          this.state.selectedRow && this.state.selectedRow.includes(row._id)
            ? true
            : false
        }
        onClick={(event) => this.handleCheckBoxClick(event, row._id)}
      />
    );
  }

  handleCheckBoxClick = (e, id) => {
    let { selectedRow } = this.state;
    if (selectedRow && selectedRow.includes(id)) {
      if (selectedRow.length > 0) {
        const index = selectedRow.indexOf(id);
        if (index > -1) {
          selectedRow.splice(index, 1);
        }
      }
    } else {
      if (id) {
        selectedRow.push(id);
      }
    }
    this.setState({ selectedRow: selectedRow });
  };

  deleteMailingTypeListUser(row) {
    this.setState({ currentSelectedRow: row, openDeleteConfirmPopup: true });
  }

  showOpenPopup = (open, userList) => {
    this.setState({ open: open, userList: userList, selectedRow: [] });
  };

  notifyFormError(data, msg) {
    console.error("Form error:", data);
    alert(msg);
  }

  closeUserListModal = () => {
    this.setState({ open: false, userList: {} });
    this.props.closeShowPopup();
  };

  // This method is used for searching
  submitSearchForm(searchText) {
    var me = this;
    if (searchText != "" && searchText != null) {
      this.setState({ isLoading: false, searchTextValue: searchText });
    } else {
      this.setState({ searchTextValue: "" });
    }
  }

  clearSearchText = () => {
    this.setState({ searchTextValue: "", open: false });
    this.getAllCompanies();
  };

  closeDeleteConfirmPopup = () => {
    this.setState({ openDeleteConfirmPopup: false });
  };

  render() {
    let { userList, open, searchTextValue, openDeleteConfirmPopup } =
      this.state;
    return (
      <div>
        <Dialog open={open}>
          <div>
            <div style={{ display: "inline-block", fontWeight: "600" }}>
              User List
            </div>
            <div
              className="searchTextCls"
              style={{ display: "inline-block", marginLeft: "1em" }}
            >
              <input
                type="text"
                value={searchTextValue}
                className="searchInputCls"
                placeholder="Search Name"
                onChange={(e) => this.submitSearchForm(e.target.value)}
              />
              <span
                className="searchImgCls"
                onClick={() => {
                  this.clearSearchText();
                }}
              >
                <img src={searchIcon} style={{ width: "16px" }} />
              </span>
            </div>
            <div style={{ display: "inline-block", float: "right" }}>
              <IconButton
                onClick={this.closeUserListModal}
                style={{ width: "25px", height: "25px" }}
              >
                <img src={closeIcon} />
              </IconButton>
            </div>
          </div>
          <div style={{ height: "500px", overflowY: "auto" }}>
            <BootstrapTable data={userList} bordered={false} pagination>
              <TableHeaderColumn
                isKey={true}
                dataField="_id"
                width="120"
                hidden={true}
              >
                Id
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="button"
                dataFormat={this.checkButtonFormatter}
                width="20"
              ></TableHeaderColumn>
              <TableHeaderColumn
                dataField="name"
                width="80"
                tdStyle={{ background: "#fff" }}
              >
                Name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="email"
                width="80"
                tdStyle={{ background: "#fff" }}
              >
                Email
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="button"
                dataFormat={this.buttonFormatter}
                width="20"
                tdStyle={{ background: "#fff" }}
              >
                Action
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </Dialog>
        <Dialog
          title="Delete User"
          open={openDeleteConfirmPopup}
          onRequestClose={this.closeDeleteConfirmPopup}
          style={{ width: "50%", textAlign: "center" }}
        >
          Are you sure you want to delete this user?
          <br />
          <br />
          <FlatButton
            type="button"
            className="flatButtonCls"
            onTouchTap={this.closeDeleteConfirmPopup}
          >
            Yes
          </FlatButton>
          <FlatButton
            type="button"
            style={{ marginLeft: "2rem" }}
            className="flatButtonCls"
            onTouchTap={this.closeDeleteConfirmPopup}
          >
            No
          </FlatButton>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/documentUploader/ShowUserList.js